import React, { useState } from "react";
import FormInput from "../../../../form-input/form-input.component";
import registerForm from "../../../../../../pages/pre-auth/register/forms/register.forms";
import formValidityCheck from "../../../../../utils/validator";
import AppService from "../../../../../services/app-service";
import { ucsfInstance } from "../../../../../axios/ucsf";
import { COMPONENT_APIS } from "../../../../../utils/omi-api";
import { setLoader } from "../../../../../../redux/app/app.actions";
import { useDispatch } from "react-redux";

const RegisterFlow = ({ onViewChange }) => {
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({
    registerFormData: { ...registerForm },
    formIsValid: false,
    loading: false,
  });
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState("");

  const { registerFormData, formIsValid, loading } = userData;

  const inputChangedHandler = (event, identifier) => {
    let formIsValid = true;
    const updatedRegisterForm = { ...registerFormData };
    const updatedFormElement = { ...updatedRegisterForm[identifier] };
    updatedFormElement.value = event.target.value;
    const { validity, errorMessage } = formValidityCheck(
      updatedFormElement,
      updatedRegisterForm,
    );
    updatedFormElement.valid = validity;
    if (updatedFormElement.validation)
      updatedFormElement.validation.message = errorMessage;
    updatedFormElement.touched = true;
    updatedRegisterForm[identifier] = updatedFormElement;
    for (let id in updatedRegisterForm) {
      formIsValid = updatedRegisterForm[id].valid && formIsValid;
    }
    setUserData({
      ...userData,
      registerFormData: updatedRegisterForm,
      formIsValid,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    AppService.clearAllCookies();
    localStorage.clear();
    dispatch(setLoader(true));
    const newUserObject = {
      first_name: registerFormData.firstName.value,
      last_name: registerFormData.lastName.value,
      email: registerFormData.email.value,
      username: registerFormData.userName.value,
      password: AppService.encryptData(registerFormData.password.value),
      confirm_password: registerFormData.confirmPassword.value,
      institution: registerFormData.institution.value,
      orcid_id: registerFormData.orcidID.value,
    };
    for (let key in newUserObject) {
      if (!newUserObject[key]) delete newUserObject[key];
    }
    ucsfInstance
      .post(COMPONENT_APIS.USER_REG, newUserObject)
      .then(() => {
        setRegisterSuccess(true);
        dispatch(setLoader(false));
        AppService.setNotification({
          title: "User Registration Successful",
          message: "A verification link has been sent to the email that you've provided. Please click on the link inside to verify.",
          type: "success",
          duration: 5000,
        });
        onViewChange("login");
      })
      .catch((err) => {
        const regErr = err?.response?.data?.error || err?.error;
        setRegistrationError(
          regErr || "Something went wrong. Please try again.",
        );
        dispatch(setLoader(false));
      });
  };

  return (
    <>
      <div className="auth-card-header">
        <h2 className="auth-card-title">Create Account</h2>
        <p className="auth-card-subtitle">
          Fill in the details below to join OMICON
        </p>
      </div>

      {registrationError && (
        <div className="auth-error-message">{registrationError}</div>
      )}

      {!registerSuccess && (
        <form onSubmit={handleSubmit} className="auth-card-form">
          <div className="auth-card-content">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Username</label>
                <FormInput
                  elementType={registerFormData.userName.elementType}
                  elementConfig={registerFormData.userName.elementConfig}
                  value={registerFormData.userName.value}
                  changed={(event) => inputChangedHandler(event, "userName")}
                  touched={registerFormData.userName.touched}
                  invalid={!registerFormData.userName.valid}
                  shouldValidate={registerFormData.userName.validation}
                  errorMessage={registerFormData.userName.validation?.message}
                />
              </div>
              <div className="form-group">
                <label className="form-label">First Name</label>
                <FormInput
                  elementType={registerFormData.firstName.elementType}
                  elementConfig={registerFormData.firstName.elementConfig}
                  value={registerFormData.firstName.value}
                  changed={(event) => inputChangedHandler(event, "firstName")}
                  touched={registerFormData.firstName.touched}
                  invalid={!registerFormData.firstName.valid}
                  shouldValidate={registerFormData.firstName.validation}
                  errorMessage={registerFormData.firstName.validation?.message}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Last Name</label>
                <FormInput
                  elementType={registerFormData.lastName.elementType}
                  elementConfig={registerFormData.lastName.elementConfig}
                  value={registerFormData.lastName.value}
                  changed={(event) => inputChangedHandler(event, "lastName")}
                  touched={registerFormData.lastName.touched}
                  invalid={!registerFormData.lastName.valid}
                  shouldValidate={registerFormData.lastName.validation}
                  errorMessage={registerFormData.lastName.validation?.message}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <FormInput
                  elementType={registerFormData.email.elementType}
                  elementConfig={registerFormData.email.elementConfig}
                  value={registerFormData.email.value}
                  changed={(event) => inputChangedHandler(event, "email")}
                  touched={registerFormData.email.touched}
                  invalid={!registerFormData.email.valid}
                  shouldValidate={registerFormData.email.validation}
                  errorMessage={registerFormData.email.validation?.message}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Password</label>
                <FormInput
                  elementType={registerFormData.password.elementType}
                  elementConfig={registerFormData.password.elementConfig}
                  value={registerFormData.password.value}
                  changed={(event) => inputChangedHandler(event, "password")}
                  touched={registerFormData.password.touched}
                  invalid={!registerFormData.password.valid}
                  shouldValidate={registerFormData.password.validation}
                  errorMessage={registerFormData.password.validation?.message}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <FormInput
                  elementType={registerFormData.confirmPassword.elementType}
                  elementConfig={registerFormData.confirmPassword.elementConfig}
                  value={registerFormData.confirmPassword.value}
                  changed={(event) =>
                    inputChangedHandler(event, "confirmPassword")
                  }
                  touched={registerFormData.confirmPassword.touched}
                  invalid={!registerFormData.confirmPassword.valid}
                  shouldValidate={registerFormData.confirmPassword.validation}
                  errorMessage={
                    registerFormData.confirmPassword.validation?.message
                  }
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  Institution{" "}
                  <span
                    style={{
                      fontWeight: 400,
                      textTransform: "none",
                      fontSize: "0.7rem",
                      color: "#999",
                    }}
                  >
                    (optional)
                  </span>
                </label>
                <FormInput
                  elementType={registerFormData.institution.elementType}
                  elementConfig={registerFormData.institution.elementConfig}
                  value={registerFormData.institution.value}
                  changed={(event) => inputChangedHandler(event, "institution")}
                  touched={registerFormData.institution.touched}
                  invalid={!registerFormData.institution.valid}
                  shouldValidate={registerFormData.institution.validation}
                  errorMessage={
                    registerFormData.institution.validation?.message
                  }
                />
              </div>
              <div className="form-group">
                <label className="form-label">
                  ORCID ID{" "}
                  <span
                    style={{
                      fontWeight: 400,
                      textTransform: "none",
                      fontSize: "0.7rem",
                      color: "#999",
                    }}
                  >
                    (optional)
                  </span>
                </label>
                <FormInput
                  elementType={registerFormData.orcidID.elementType}
                  elementConfig={registerFormData.orcidID.elementConfig}
                  value={registerFormData.orcidID.value}
                  changed={(event) => inputChangedHandler(event, "orcidID")}
                  touched={registerFormData.orcidID.touched}
                  invalid={!registerFormData.orcidID.valid}
                  shouldValidate={registerFormData.orcidID.validation}
                  errorMessage={registerFormData.orcidID.validation?.message}
                />
              </div>
            </div>

            <div className="auth-card-button-group">
              <button
                className="auth-card-button primary"
                onClick={handleSubmit}
                type="submit"
                disabled={!formIsValid || loading}
              >
                Sign Up
              </button>
            </div>
          </div>
        </form>
      )}

      <div className="auth-card-footer-links">
        <span className="auth-card-text">
          Already have an account?{" "}
          <button
            type="button"
            className="auth-card-link"
            onClick={() => onViewChange("login")}
          >
            Log In
          </button>
        </span>
      </div>
    </>
  );
};

export default RegisterFlow;
